import React from 'react';
import { TrustBadge } from '../ui/TrustBadge';
import { MapPin, Server, CreditCard, Lock } from 'lucide-react';
export function TrustBadgesSection() {
  const badges = [{
    icon: <MapPin size={24} data-id="element-125" />,
    label: 'UK-Based',
    description: 'Proudly serving British businesses with local support.'
  }, {
    icon: <Server size={24} data-id="element-126" />,
    label: 'Modern SaaS Platform',
    description: 'Built on the latest cloud technology for reliability.'
  }, {
    icon: <CreditCard size={24} data-id="element-127" />,
    label: 'Clear Pricing',
    description: 'Transparent costs with no hidden fees.'
  }, {
    icon: <Lock size={24} data-id="element-128" />,
    label: 'Secure Payments',
    description: 'Bank-grade encryption for all transactions.'
  }];
  return <section className="py-20 bg-slate-50" data-id="element-129">
      <div className="container mx-auto px-4 md:px-6" data-id="element-130">
        <div className="text-center mb-12" data-id="element-131">
          <h2 className="text-3xl font-bold text-slate-900 mb-4" data-id="element-132">
            Why Choose HomeLinkPro?
          </h2>
          <p className="text-slate-600 max-w-2xl mx-auto" data-id="element-133">
            We provide a secure, reliable foundation for your business
            operations.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-134">
          {badges.map((badge, index) => <TrustBadge key={index} icon={badge.icon} label={badge.label} description={badge.description} data-id="element-135" />)}
        </div>
      </div>
    </section>;
}